export const OrganizationDocumentData = {
  domainId: 0,
  documents: [
    {
      "id": 0,
      "name": "",
      "fileUrl": "",
      "fileType": "",
      "documentTypeId": 24
    },
    {
      "id": 0,
      "name": "",
      "fileUrl": "",
      "fileType": "",
      "documentTypeId": 22
    }
  ]
}